import React from 'react';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';

export default withStyles(theme => ({
  root: {
    width: 48,
    height: 26,
    padding: 0,
    display: 'flex'
  },
  switchBase: {
    padding: 2,
    color: theme.palette.common.white,
    '& + $track': {
      backgroundColor: theme.palette.grey[500],
      borderColor: theme.palette.grey[500]
    },
    '&$checked': {
      transform: 'translateX(22px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: `${theme.palette.primary.main} !important`,
        borderColor: theme.palette.primary.main
      }
    }
  },
  thumb: {
    width: 22,
    height: 22,
    boxShadow: 'none'
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 26 / 2,
    opacity: 1,
    backgroundColor: theme.palette.common.white
  },
  checked: {},
  disabled: {
    color: '#fff !important'
  }
}))(({ classes, ...props }) => (
  <Switch
    focusVisibleClassName={classes.focusVisible}
    disableRipple
    classes={{
      root: classes.root,
      switchBase: classes.switchBase,
      thumb: classes.thumb,
      track: classes.track,
      checked: classes.checked,
      disabled: classes.disabled
    }}
    {...props}
  />
));
